export default __webpack_public_path__ + "static/media/ElenaIVTS.d0b61b87.pdf";